// Fallback UUID generator (secure)
function generateFallbackUUID() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> c / 4))
        ).toString(16)
    );
}

export function getAppRuid() {
    // Check if ID already exists
    let ruid = localStorage.getItem('x-app-ruid');

    if (!ruid) {
        // Prefer crypto.randomUUID if available
        if (crypto.randomUUID) {
            ruid = crypto.randomUUID();
        } else {
            ruid = generateFallbackUUID();
        }

        localStorage.setItem('x-app-ruid', ruid);
    }

    return ruid;
}
